import {
  AppRuntimeConfiguration,
  computeItemIdentifier,
} from '@o3r/core';
import {
  COMPONENTS_CONFIGURATION_NAME,
} from '../configuration/dynamic-configuration';

/**
 * App configuration
 *
 * @title Application
 */
export interface AppConfig extends AppRuntimeConfiguration {

  /**
   * List of DxAPI error codes that should redirect the user to the recovery page
   *
   * @o3rCategory functionalities
   * @o3rRestrictionKey global
   */
  errorCodesRedirectingToRecovery: string[];

  /**
   * Whether to enable resume booking feature
   *
   * @o3rCategory functionalities
   * @o3rRestrictionKey global
   */
  shouldEnableResumeBooking: boolean;
}

export const APP_CONFIG_DEFAULT: AppConfig = {
  errorCodesRedirectingToRecovery: [],
  shouldEnableResumeBooking: false
};

export const APP_CONFIG_ID = computeItemIdentifier('AppConfig', COMPONENTS_CONFIGURATION_NAME);
